import { Layout } from "@/components/layout";
import { Heading, Paragraph } from "@/components/Typography";

export default function AboutMePage() {
  return (
    <Layout>
      <Heading level="h2">About Me</Heading>
      <img src="/about_me.gif" alt="About Me GIF" className="mx-auto rounded-lg shadow-lg w-1/2 mb-6" />
      <div className="space-y-6 text-gray-600 dark:text-gray-400">
        <Paragraph>
          I'm living in Zurich but originally from Porto, Portugal. I moved to Zurich in 2024 and since then, I have been surviving with "mit karte bitte," "grüezi," and "tanke" — slowly improving my dictionary though!
        </Paragraph>
        <Paragraph>
          I work as a Software Engineer in the Security Engineering Department at <a href="https://www.coalitioninc.com" className="underline text-gray-600 dark:text-gray-400 hover:underline">Coalition</a>. My work helps Coalition assess cyber risk for entities by building tools for security data access, analyzing threat feeds, and developing automation for large-scale scanning. You can find more details about my experience in my <a href="[YOUR_CV_LINK]" className="underline text-gray-600 dark:text-gray-400 hover:underline">CV</a>.
        </Paragraph>
      </div>
    </Layout>
  );
}
